import { State } from '.';
import { User } from '../../models/user';

export const selectors = {
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getUser: (
        state: State,
        id: Undefinable<DictionaryKey>
    ): Undefinable<User> => state.byId[id || ''],
    getUserHash: (
        state: State
    ): Dictionary<User> => state.byId,
    getUserIds: (
        state: State
    ): string[] => state.allIds
};
